<template>
  <div>
    <div>
      <div class="d-flex align-items-center mb-2 ml-2">
        <b-form-checkbox id="selecionar-todos"
                         @change="selecionarTodosItens"> 
          <label for="selecionar-todos" 
                 class="mr-4">Selecionar todos os itens
          </label>
        </b-form-checkbox>
        <div class="d-flex align-items-center h-25 mb-2">
          <button class="btn btn-sm btn-default btn-excluir d-flex align-items-center justify-content-between font-weight-bold"
                  type="button"
                  :disabled="!lixeiraHabilitada"
                  @click="excluir($bvModal)">
            <IconSvg class="Excluir-icon icon--sm trash"
                     icon="trash" />
            Excluir
          </button>
        </div>
      </div>
    </div>  
    <table class="w-100">
      <thead :style="color">
        <tr>
          <td class="text-left pl-5">
            Data
          </td>
          <td class="text-left pl-2">
            Tipo de serviço
          </td>
          <td class="text-left pl-3"> 
            Beneficiario
          </td>
          <td class="text-left pl-2"> 
            Valor
          </td>
          <td />
        </tr>
      </thead>
      <tbody class="table dados-da-tabela border-top-0">
        <tr v-for="item in frenteCaixa.pedidos" 
            :key="item.cx_pedido_id = item.cx_lancamento_id ">
          <td class="text-left td-dados">
            <b-form-checkbox 
              v-model="item.habilitar"
              @change="checkboxIndividualHabilitado"> 
              <span class="text-left td-dados pl-2">
                {{ item.data_lancamento | date }}
              </span>
            </b-form-checkbox>
          </td>
          <td class="text-left td-dados">
            {{ item.tipo }}
          </td>
          <td class="text-left td-dados pl-3">
            {{ item.beneficiario || '---' }}
          </td>
          <td class="text-left td-dados">
            <input id="custa_valor_total_custa"
                   v-money="money"
                   :value="item.valor_total"
                   disabled
                   class="text-left text-danger"
                   :class="{'is-invalid' : errors.has('custa_ipesp')}"
                   name="custa_ipesp"
                   size="10px"
                   trim>
          </td>
          <td class="text-left pt-3">
            <ModalEditarDespesa v-if="caixaStore.aberto"
                                :prop-pagamento="item"
                                :prop-atualizar-status="atualizarStatus" />
          </td>
        </tr>
      </tbody>
    </table>
    <ConfirmacaoExclusaoLancamento 
      :prop-itens-habilitados="itensHabilitados" 
      @verificar="verificarExclusaoLancamento" />
    <RemocaoLancamento 
      :atualizar-lancamentos-de-pagamentos="[atualizarLancamentosDePagamentos, 'pagamentosAvulsos']" 
      @mensagem="msgTextArea" />
  </div>
</template>

<script>
 //Components
  import ModalEditarDespesa from "../../ModalEditar/ModalEditarDespesa.vue"
  import RemocaoLancamento from "../../RemocaoLancamento/RemocaoLancamento" 
  import ConfirmacaoExclusaoLancamento from "../../RemocaoLancamento/ConfirmacaoExclusaoLancamento" 

  // vuex
  import { mapState } from 'vuex'

  // Imports
  import { VMoney } from 'v-money'
  import  lancamentoService from '../../../lancamentoService'
  import  pedidoService from '../../../pedidoService'

  export default {
    name: "TabelaPagamentosAvulsos",
    directives: {
      money: VMoney
    },
    components: {
      ModalEditarDespesa,
      RemocaoLancamento,
      ConfirmacaoExclusaoLancamento
    },
    data () {
      return {
        color: {
          backgroundColor: "#57bd9c",
        },
        lixeiraHabilitada: false,
        arrayExcluidos: [],
        textoJustificativa: '',
        corfirmarExclusao: false,
        itensHabilitados: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
        filtro: {
          status: 'concluido',
          tipoServico: '',
          data: '',
          numOs: '',
          solicitante: '',
          formaPg: '',
          page: 1,
          perPage: 20,
          lastPage: '',
        },
      }
    },
    computed: { 
      ...mapState(['frenteCaixa']),
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
    },
    methods: {
      selecionarTodosItens (event) {
        this.frenteCaixa.pedidos.forEach(obj => {
          if (!event) {
            obj.habilitar = false
            this.lixeiraHabilitada = false
            return
          } else if (event &&  this.lixeiraHabilitada ) {
            this.lixeiraHabilitada = false
          }

          obj.habilitar = true
          this.lixeiraHabilitada = true
        })
      },
      checkboxIndividualHabilitado (event) {
        if (event) return this.lixeiraHabilitada = true
        const habilitados =  this.frenteCaixa.pedidos.filter(obj => obj.habilitar)
       
        if (habilitados.length > 1) {
          this.lixeiraHabilitada = true
          
        } else if (habilitados.length == 1 ) {
          this.lixeiraHabilitada = false
          habilitados[0].habilitar = false 
        } 
      },
      async atualizarStatus () {
        this.$store.dispatch('frenteCaixa/atualizarPedidos')
      },
      excluir (mostrarModal) {
        this.itensHabilitados =  this.frenteCaixa.pedidos.filter(obj => obj.habilitar)

        if (!this.corfirmarExclusao) {
          mostrarModal.show('show-modal-confirmacao-lancamento')
        }
       
        if (this.corfirmarExclusao) {
          mostrarModal.show('show-modal-confirmacao')
          this.corfirmarExclusao = false
        }
      },
      atualizarLancamentosDePagamentos () {
        this.atualizarStatus ()
        this.arrayExcluidos = []
        this.lixeiraHabilitada = false
        this.textoJustificativa = ''
        this.itensHabilitados = []
      },
      async msgTextArea (texto) {
        try {
          this.textoJustificativa = texto
          this.frenteCaixa.pedidos.forEach( item => item.habilitar && this.arrayExcluidos.push(item.cx_lancamento_id))
          await lancamentoService.excluirPagamentosAvulsos({arrayExcluidos: this.arrayExcluidos, msg: this.textoJustificativa })
        
          setTimeout (() => {
            this.mensagemDeExclusao()
          }, 2000)
          this.atualizarLancamentosDePagamentos()
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        }
      },
      mensagemDeExclusao () {
        objSwal.success.title = this.arrayExcluidos.length ? this.arrayExcluidos.length  > 1 ? `Lançamentos excluídos com sucesso.` : `Lançamento excluído com sucesso.` : ''
        Swal.fire(objSwal.success)  
      },
      verificarExclusaoLancamento (modal) {
        this.corfirmarExclusao = true
        this.excluir(modal)
      }
    }
  }
</script>

<style scoped>
    .trash {
      width:15px;
    }
    .btn-excluir {
      cursor:pointer;
      font-size: 1.2rem;
      width:100px;
    }
    .vazio {
      padding-left:120px;
    }
    thead {
      border-right: 1.5px solid #57bd9c;
      border-left: 1px solid #57bd9c;
      font-size:1.2rem;
      font-weight: bolder;
    }
    .dados-da-tabela {
      border: 0.5px solid #C6C6C6;
    }
    tbody tr {
      border-top: 0.5px solid #C6C6C6;
    }
    tbody tr:hover {
      background-color:#f5f5f5;
      cursor:pointer;
    }
    td {
      width: 16%;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .td-dados {
      width: 16%;
      padding-top: 25px;
      padding-bottom: 25px;
    }
</style>
